// @flow
export const marginMobile = 1;
export const marginTablet = marginMobile * 1.5;
export const marginDesktop = marginMobile * 2;

export const borderRadius = 0.5;

export const iconsContainerHeight = 5;
export const textContainerHeight = 7;
export const controlPanelHeight = 2.5;
export const detailsPadding = 0.8;

export const recipeItemAnimationDuration = 500;

export const bezier = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const iconContainerSize = 1.75;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/style-variables.js